﻿$.fn.dxCtrlPageNewCompte = function custom_dxCtrlPageNewCompte(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlpagenewcompte dx-ctrl");
        this.createInstance(new cdxCtrlPageNewCompte(this, option));
    }
    return this;
}

window.cdxCtrlPageNewCompte = function (container, option) {
    var Me = this;

    for (let i = 1; i <= 20; i++) {
        $('<img/>')[0].src = parametre.urldispatch + "/img/imglogin/" + parametre.baseAppli.code_appli_general + "/img" + i + ".jpg"
    }


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivConnexion = null
    var dxAdrEmail = null
    var compteClient = null
    var $DivBoxLoginCenter = null
    var $DivDemarrage = null

    var mailExistePas = null;
    var popupNew = null
    function mConstruit() {
        container.empty()

        popupNew = $("<div/>").appendTo("body").dxPopup({
            fullscreen: true,
            showTitle: false,
            contentTemplate: function (contentElement) {
                if (parametre.isPhone) contentElement.css("padding", "0")
                mRempli(contentElement)
            }
        }).dxPopup("instance")
        window.setTimeout(function () {
            popupNew.show()
            //window.setTimeout(function () { popupNew.show() }, 1500)
        }, 0)
    }

    var $DivInfo = null
    function mRempli(contentElement) {


        contentElement.css("position", "relative")

        var $DivBoxImg = $("<div style='width:calc(100% - 275px - 20%);position:absolute;left:0;top:0;height:100%;'/>").appendTo(contentElement);
        var $DivBoxImg = $("<div style='width:100%;height:100%;position:relative;'/>").appendTo($DivBoxImg);
        var $DivBoxImg1 = $("<div style='width:100%;height:100%;position:absolute;display:none;'/>").appendTo($DivBoxImg)
        function mLoadImage(oldidx) {
            var idxImage = Math.floor(Math.random() * 20) + 1;
            if (idxImage == oldidx) { mLoadImage(oldidx) }
            else {
                var $DivBoxImg2 = $("<div style='width:100%;height:100%;position:absolute;display:none;'/>").appendTo($DivBoxImg)
                $DivBoxImg2.css({
                    "background-image": "url('" + parametre.urldispatch + "/img/imglogin/" + parametre.baseAppli.code_appli_general + "/img" + idxImage + ".jpg')",
                    "background-size": "cover",        /* Pour couvrir tout le bloc */
                    "background-position": "center",   /* Centrer l'image */
                    "background-repeat": "no-repeat"  /* Ne pas répéter l'image */
                })
                var $DivBoxOld = $DivBoxImg1
                $DivBoxOld.fadeOut(600, function () { $DivBoxOld.remove() })
                $DivBoxImg2.fadeIn(600, function () { $DivBoxImg1 = $DivBoxImg2 })
                window.setTimeout(function () { mLoadImage(idxImage) }, 6000)
            }

        }
        mLoadImage(null)


        var $DivBoxRight = $("<div style='width:calc(275px + 20%);position:absolute;right:0;top:0;height:100%;display:flex;align-items:center;justify-content:center;overflow:auto;'/>").appendTo(contentElement);
        var $DivBoxRightInner = $("<div style='width:100%;padding:0 15%'/>").appendTo($DivBoxRight);

        var $Asupport = $("<a href='javascript:void(0)' style='font-size:100%;position:absolute;bottom:10px;left:10px;'>Contacter le support</a>").appendTo($DivBoxRightInner)
        $Asupport.on("click", function () {
            ////log la demande
            //mCapturerPageImage(function (imgData) {
            //    imgData
            //    var urlHandler = '/ext/handlerexterne.ashx?timestamp=' + new Date().getTime();
            //    var dataToBeSent = {
            //        command: "writeimagdatascreenlog",
            //        id_log: data.root.id_log,
            //        img_data_screen: imgData
            //    };
            //    $.post(urlHandler, dataToBeSent, function (data) { }, 'json')
            //        .fail(function (data) { })
            //        .always(function (data) { });
            //})
            window.open(parametre.url_site_vitrine + "#contact", "_blank")
        })
        //$("<a href='" + parametre.url_appli + "' style='font-size:100%;position:absolute;bottom:10px;right:10px;' target='_self'>Se connecter</a>").appendTo($DivBoxRightInner)

        var $DivBoxLogin = $("<div style=''/>").appendTo($DivBoxRightInner);
        $DivBoxLoginCenter = $("<div style=''/>").appendTo($DivBoxLogin);

        document.title = parametre.nom;
        var $DivImg = $("<div style='text-align:center;'/>").appendTo($DivBoxLoginCenter)
        //var $Table = $("<table/>").appendTo($DivImg)
        //var $Tr = $("<tr/>").appendTo($Table)
        //var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        //var $Img = $("<img src='" + parametre.url_gif + "' style='width:70px'/>").appendTo($Td)
        var $Img = $("<img src='" + parametre.url_gif + "' style='width:70px'/>").appendTo($DivImg)

        var $Div = $("<div class='dx-theme-accent-as-background-color'/>").appendTo($DivBoxRightInner);
        backgroundcolorAccent = $Div.css("background-color");
        $Div.remove();
        $DivInfo = $("<div/>").appendTo($DivImg)
        $("<div style='font-size:44px;font-weight:bold;color: white;text-shadow: 1px 1px 2px black, 0 0 2px " + backgroundcolorAccent + ", 0 0 5px " + backgroundcolorAccent + ";line-height:0.9;'><span style='font-size:50%;'>Démarrer avec</span><br/><span style='font-family:bangers;'>" + parametre.nom + "</span></div>").appendTo($DivInfo)
        var $DivLib = $("<div style='font-size:180%;line-height:0.8;padding-top:10px;'>Créer votre environnement</div>").appendTo($DivInfo)
        if (parametre.has_environnement_demo) {
            $("<span><br/><span style='font-size:50%;'>- OU -</span><br/>démarrer une démo</span>").appendTo($DivLib)
        }

        $DivConnexion = $("<div/>").appendTo($DivBoxLoginCenter);
        $DivDemarrage = $("<div/>").appendTo($DivBoxLoginCenter);

        $("<br/>").appendTo($DivConnexion)
        $("<br/>").appendTo($DivConnexion)
        $("<div>Saisissez votre adresse email de connexion:</div>").appendTo($DivConnexion)
        var $Table = $("<table/>").appendTo($DivConnexion)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        dxAdrEmail = $("<div/>").appendTo($Td).dxCtrlTextEmail({
            labelMode: 'floating',
            label: "Adresse email",
            value: option.ema,
            placeholder: "Adresse email de connexion..." + String.fromCharCode(160),
            width: "100%",
            mode: "email",
            onKeyUp: function (e) {
            },
            onValueChanged: function (e) {
                onValueChangedEmail(e)
            },
            onContentReady: function (e) {
                window.setTimeout(function () {
                    dxAdrEmail.element().find('.dx-texteditor-input').off('keydown.next')
                    dxAdrEmail.element().find('.dx-texteditor-input').on('keydown.next', function (e) {
                        const key = e.key || e.keyCode || e.which;
                        if (key === 'Enter' || key === 13) {
                            e.preventDefault();
                            dxFocus.focus()
                        }
                    });
                }, 0)
                window.setTimeout(function () {
                    popupNew.focus()
                    dxAdrEmail.focus()
                }, 500)
            }
        }).dxCtrlTextEmail("instance")
        var $Td = $("<td style='max-width:0px;opacity:0;'/>").appendTo($Tr)
        var dxFocus = $("<div/>").appendTo($Td).dxTextBox({}).dxTextBox("instance")
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        var $btArrowEmail = $("<div class='allowcontextmenu' style='display:inline-block;padding-left:5px;'/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-arrow-right",
            height: 45,
            width: 45,
            onClick: function (e) {
                onValueChangedEmail({ value: dxAdrEmail.option("value") })
            }
        }).dxCtrlButton("instance");

        window.setTimeout(function () { dxAdrEmail.focus(); }, 0)
        function onValueChangedEmail(e) {
            var lstNotTrash = [
                "mailinator.com",
                "tempmail.com",
                "guerrillamail.com",
                "10minutemail.com",
                "yopmail.com",
                "temp-mail.org",
                "tempmail.org",
                "throwawaymail.com",
                "trashmail.com",
                "getnada.com",
                "dispostable.com",
                "fakeinbox.com",
                "maildrop.cc",
                "moakt.com",
                "emailondeck.com",
                "mintemail.com",
                "spamgourmet.com",
                "mytrashmail.com",
                "mailnesia.com",
                "sharklasers.com",
                "grr.la",
                "guerrillamailblock.com",
                "guerrillamail.net",
                "guerrillamail.org",
                "guerrillamail.biz",
                "guerrillamail.de",
                "pokemail.net",
                "spam4.me",
                "bccto.me",
                "chacuo.net",
                "tmpmail.net",
                "tempinbox.com",
                "mailcatch.com",
                "mailinator.net",
                "mailinator.org",
                "mailinator2.com",
                "mailmetrash.com",
                "spambog.com",
                "spambog.de",
                "spambog.ru",
                "spambox.us",
                "spamfree24.org",
                "temporarymail.com",
                "trashmail.net",
                "trashmail.de",
                "wegwerfemail.de",
                "wegwerfmail.de",
                "jetable.org",
                "jetable.com",
                "mail-temporaire.fr",
                "emailtemporanea.com",
                "fakemailgenerator.com",
                "tempail.com",
                "tempr.email",
                "dropmail.me",
                "dropmail.org",
                "dropmail.info",
                "burnermail.io",
                "simplelogin.com",
                "anonaddy.com"
            ]
            if (dxAdrEmail.option("value") == null || dxAdrEmail.option("value").length == 0) {
                mNotify("Veuillez saisir une adresse email pour vous connecter à votre compte.", "warning", 6000)
                dxAdrEmail.focus()
                return;
            } else if (lstNotTrash.filter(function (o) { return dxAdrEmail.option("value").endsWith(o) }).length > 0) {
                mNotify("Impossible d'utiliser ce type d'adresse email.", "warning", 6000)
                dxAdrEmail.focus()
                return;
            } else if (!dxAdrEmail.hasErreur && e.value != null && e.value.length > 0) {
                if (parametre.code_appli == 'ppmasc' && !e.value.endsWith("@ppmascaron.eu")) {
                    //on est en preprod
                    //oblige mail "@ppmascaron.eu"
                    forcerFermetureNavigateur = true;
                    window.open("https://app.mascaron.eu/new", "_self")
                }
                $btArrowEmail.option("visible", false)
                dxAdrEmail.option("disabled", true)
                option.bddCtrl.mAjaxCall({ command: "getcompteclientemailnombasefrommail", email: e.value }, function (data) {
                    compteClient = data
                    if (typeof data.email == 'undefined') {
                        //le mail n'est rattaché à aucun client
                        option.bddCtrl.mAjaxCall({ command: "getutilisateuremailnombasefrommail", email: e.value }, function (data) {
                            if (typeof data.email != 'undefined') {
                                //on a trouvé un compte utilisateur
                                mRempliPourCompteUtilisateurAvecBase(data.email)
                            } else {
                                mailExistePas = e.value
                                $("<div/>").appendTo($DivBoxRightInner).dxCtrlSaisieCode({
                                    bddCtrl: option.bddCtrl,
                                    title: "Confirmez votre email",
                                    adresse_email: mailExistePas,
                                    from: "page new compte (dxCtrlPageNewCompte)",
                                    onValide: function () {
                                        mRempliPourCompteExistePas()
                                        dxAdrEmail.option("disabled", true)
                                        $btArrowEmail.option("visible", false)
                                    },
                                    onCancel: function () {
                                        dxAdrEmail.option("disabled", false)
                                        $btArrowEmail.option("visible", true)
                                    }
                                })
                            }
                        })
                    } else if (data.nopwd == "1") {
                        //le compte client existe mais on a pas de mot de passe
                        mRempliPourCompteExisteSansPwd(e.value)
                    } else if (data.email_verify == "0") {
                        //le compte client existe mais l'email n'est pas vérifié
                        $("<div/>").appendTo($DivBoxRightInner).dxCtrlSaisieCode({
                            bddCtrl: option.bddCtrl,
                            title: "Confirmez votre email",
                            adresse_email: e.value,
                            from: "page new compte (dxCtrlPageNewCompte)",
                            onValide: function () {
                                option.bddCtrl.mAjaxCall({ command: "valideemailcompteclientnoverify", adresse_email: e.value }, function (data) {
                                    onValueChangedEmail({ value: e.value })
                                })
                            },
                            onCancel: function () {
                                dxAdrEmail.option("disabled", false)
                                $btArrowEmail.option("visible", true)
                            }
                        })
                    } else if (data.nom_base.length == 0) {
                        //le compte client existe mais on a pas de base
                        dxAdrEmail.option("disabled", true)
                        $btArrowEmail.option("visible", false)
                        mailExistePas = null
                        mRempliPourCompteExisteSansBase()
                    } else {
                        //le compte client existe et on a une base
                        dxAdrEmail.option("disabled", true)
                        $btArrowEmail.option("visible", false)
                        mailExistePas = null
                        mRempliPourCompteExisteAvecBase()
                    }
                }, null, null, false);
            }
        }
    }

    function mRempliPourCompteUtilisateurAvecBase(adresseEmail) {
        $("<br/>").appendTo($DivConnexion)
        var $Div = $("<div style='text-align:center;font-size:140%;'/>").appendTo($DivConnexion)
        $Div.hide();
        $("<div>Votre adresse email <u>" + adresseEmail + "</u> est rattachée à un compte utilisateur. Connectez vous via l'adresse</div>").appendTo($Div)
        $("<a href='" + parametre.url_appli + "' target='_self'>" + parametre.url_appli + "?emalog=" + adresseEmail + "</a>").appendTo($Div)
        $Div.slideDown(700);
    }

    var dxPwd = null;
    var dxNom = null
    var dxTel = null
    var dxChkVeuPasEtreSollicite = null
    function mRempliPourCompteExistePas() {
        $("<br/>").appendTo($DivConnexion)
        dxNom = $("<div/>").appendTo($DivConnexion).dxTextBox({
            labelMode: 'floating',
            label: "Nom (facultatif)",
            value: ""
        }).dxTextBox("instance")
        dxTel = $("<div/>").appendTo($DivConnexion).dxTextBox({
            labelMode: 'floating',
            label: "Téléphone (facultatif)",
            value: ""
        }).dxTextBox("instance")
        dxChkVeuPasEtreSollicite = $("<div style='margin:20px 0;'/>").appendTo($DivConnexion).dxCheckBox({
            text: "Je ne souhaite pas recevoir les actualités et offres de Mascaron par email.",
            value:false
        }).dxCheckBox("instance")
        //$("<div/>").appendTo($DivConnexion).dxTextBox({
        //    labelMode: 'floating',
        //    label: "Adresse postale (facultative)",
        //    value: ""
        //}).dxTextBox("instance")

        $("<br/>").appendTo($DivConnexion)
        $("<div style='opacity:1'>Créez votre mot de passe pour votre compte:</div>").appendTo($DivConnexion)

        var $Table = $("<table/>").appendTo($DivConnexion)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        dxPwd = $("<div/>").appendTo($Td).dxCtrlPwd({
        }).dxCtrlPwd("instance")
        dxPwd.element().find(".td2pwd").css("padding-top", 0)

        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        var $btArrowPwd = $("<div class='allowcontextmenu' style='display:inline-block;padding-left:5px;'/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-arrow-right",
            height: 45,
            width: 45,
            onClick: function (e) {
                if (!dxPwd.isOk()) {
                    mNotify("Veuillez saisir un mot de passe correct pour créer votre compte.<br>" + dxPwd.mGetTextErreur(), "warning", 6000)
                    dxPwd.focus()
                    return;
                }
                dxPwd.disabled(true)
                $btArrowPwd.option("visible", false)
                mRempliStart()
            }
        }).dxCtrlButton("instance");
        dxNom.focus()
    }

    function mRempliPourCompteExisteSansPwd(adresseEmail) {
        var $DivSaisie = $("<div style='text-align:center'/>").appendTo($DivConnexion)
        $("<br/>").appendTo($DivSaisie)
        $("<div style='text-align:center;padding-bottom:10px;'>Votre adresse email <u>" + adresseEmail + "</u> est liée à un compte<br/>mais c'est la première fois que vous tentez de vous connecter.</div>").appendTo($DivSaisie)
        $("<div style='opacity:0.3;text-align:center;'>Un email vous a été envoyé pour vous permettre de réinitialiser votre mot de passe.</div>").appendTo($DivSaisie)
        $("<div style='opacity:0.3;text-align:center;'>Veuillez consulter vos emails.</div>").appendTo($DivSaisie)
        $("<br/>").appendTo($DivSaisie)
        var $A = $("<a href='javascript:void(0)'>J'ai reçu le mail et j'ai créé mon mot de passe<br/>Afficher l'écran de création de compte</a>").appendTo($DivSaisie)
        $A.on("click", function (e) {
            forcerFermetureNavigateur = true
            window.open(parametre.url_appli + "/new?emalog=" + adresseEmail, "_self")
        })
        var dataToBeSent = {
            command: 'demandereinitpwdwithemail',
            adresse_email: adresseEmail,
            nom_table: "compte_client"
        }
        var url = '/ext/handlerexterne.ashx?timestamp=' + new Date().getTime();
        $.post(url, dataToBeSent, function (data) {
            if (data.root.resultat == "ok") {
                if (data.root.emailenvoye == "1") {
                    mNotify("Un email vous permettant de réinitialiser votre mot de passe vous a été envoyé. Veuillez consulter vos emails et suivre les instructions.<br/>(Si vous ne recevez pas notre email, vérifiez que celui-ci ne se trouve pas dans vos courriers indésirables)", "success", 25000)
                } else {
                    mNotify("Impossible de vous envoyer un email. Veuiller vérifier l'adresse que vous avez saisie.", "error", 15000)
                }
            }
            else {
                if (typeof data.root.message != 'undefined') { mNotify(data.root.message, "error", 5000) }
                else { mNotify("Impossible d'envoyer l'email.", "error", 15000); }
            }
        }, 'json')
            .fail(function (data) {
                console.log(data.responseText)
                mNotify("Impossible d'envoyer l'email.", "error", 15000);
            })
            .always(function (data) {
                jaugeDemarrage.mHide();
            });
    }

    function mRempliPourCompteExisteSansBase() {
        $("<br/>").appendTo($DivConnexion)
        $("<div style='text-align:center;padding-bottom:10px;'>Vous disposez d'un compte <b>" + parametre.nom + "</b><br/>mais vous ne disposez pas d'environnement.</div>").appendTo($DivConnexion)
        $("<div style='opacity:0.3'>Saisissez le mot de passe de votre compte pour créer votre environnement.</div>").appendTo($DivConnexion)
        var $Table = $("<table/>").appendTo($DivConnexion)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        dxPwd = $("<div/>").appendTo($Td).dxTextBox({
            labelMode: 'floating',
            label: "Mot de passe de votre compte",
            value: "",
            placeholder: "Mot de passe..." + String.fromCharCode(160),
            width: "100%",
            buttons: [{
                focusStateEnabled: false,
                name: 'showpwd',
                location: 'after',
                options: {
                    icon: 'eyeopen',
                    hint: "Révéler/cacher le texte",
                    focusStateEnabled: false,
                    stylingMode: 'text',
                    onClick() {
                        if (dxPwd.element().find("input").hasClass("txtPassword")) {
                            dxPwd.element().find("input").removeClass("txtPassword")
                        } else {
                            dxPwd.element().find("input").addClass("txtPassword")
                        }
                    },
                },
            }],
            onKeyUp: function (e) {
            },
            onValueChanged: function (e) {
                mConnecte()
                //if (dxPwd.option("value") != null && dxPwd.option("value").length > 0) {
                //    $btArrowPwd.option("visible", false)
                //    dxPwd.option("disabled", true)
                //    $Divoubli.hide()
                //    option.bddCtrl.mAjaxCall({ command: "verifpasswordcompteclient", adresse_email: dxAdrEmail.option("value"), pwd: dxPwd.option("value") }, function (data) {
                //        if (data.resultatpwdcompteclient == "ok") {
                //            mRempliStart()
                //        } else {
                //            $btArrowPwd.option("visible", true)
                //            dxPwd.option("disabled", false)
                //            $Divoubli.show()
                //            mNotify("Mot de passe erroné.", "warning", 6000)
                //            dxPwd.focus()
                //        }
                //    }, null, function (data) {
                //        mNotify("Impossible de vérifier le mot de passe.", "warning", 6000)
                //        $btArrowPwd.option("visible", true)
                //        dxPwd.option("disabled", false)
                //    }, false);
                //}
            },
            onContentReady: function (e) {
                e.component.element().find("input").addClass("txtPassword")
                window.setTimeout(function () { dxPwd.focus() }, 500)
            }
        }).dxTextBox("instance")
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        var $btArrowPwd = $("<div class='allowcontextmenu' style='display:inline-block;padding-left:5px;'/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-arrow-right",
            height: 45,
            width: 45,
            onClick: function (e) {
                if (dxPwd.option("value") == null || dxPwd.option("value").length == 0) {
                    mNotify("Veuillez saisir un mot de passe pour vous connecter à votre compte.", "warning", 6000)
                    dxPwd.focus()
                    return;
                }
                mConnecte()
            }
        }).dxCtrlButton("instance");

        function mConnecte() {
            if (dxPwd.option("value") != null && dxPwd.option("value").length > 0) {
                $btArrowPwd.option("visible", false)
                dxPwd.option("disabled", true)
                $Divoubli.hide()
                option.bddCtrl.mAjaxCall({ command: "verifpasswordcompteclient", adresse_email: dxAdrEmail.option("value"), pwd: dxPwd.option("value") }, function (data) {
                    if (data.resultatpwdcompteclient == "ok") {
                        mRempliStart()
                    } else {
                        $btArrowPwd.option("visible", true)
                        dxPwd.option("disabled", false)
                        $Divoubli.show()
                        mNotify("Mot de passe erroné.", "warning", 6000)
                        dxPwd.focus()
                    }
                }, null, function (data) {
                    mNotify("Impossible de vérifier le mot de passe.", "warning", 6000)
                    $btArrowPwd.option("visible", true)
                    dxPwd.option("disabled", false)
                }, false);
            }
        }


        var $Divoubli = $("<div style='text-align:right;padding-top:0px'/>").appendTo($DivConnexion)
        var $a = $("<a href='javascript:void(0)' style='font-size:10px'>J'ai oublié mon mot de passe</a>").appendTo($Divoubli)
        $a.on("click", function (e) {
            dxAdrEMailForOubli.option("value", dxAdrEmail.option("value"))
            $DivConnexion.fadeOut(300, "swing", function () { $DivOubliMotDePasse.fadeIn(300); dxAdrEMailForOubli.focus(); })
        });


        var $DivOubliMotDePasse = $("<div style='display:none;text-align:center;padding:10px'/>").appendTo($DivBoxLoginCenter);
        $("<div>Saisissez l'adresse email qui est lié à votre compte et nous vous enverrons un lien par mail pour réinitialiser votre mot de passe.</div>").appendTo($DivOubliMotDePasse)
        $("<br/>").appendTo($DivOubliMotDePasse)
        $("<br/>").appendTo($DivOubliMotDePasse)
        var dxAdrEMailForOubli = $("<div/>").appendTo($DivOubliMotDePasse).dxTextBox({
            placeholder: "Adresse email de connexion" + String.fromCharCode(160),
            width: "100%",
            onKeyUp: function (e) {
                if (e.event.keyCode == 13) { dxBtOubli.element().click(); }
            }
        }).dxTextBox("instance")
        var $DivoubliAnnule = $("<div style='text-align:right;padding-top:0px'/>").appendTo($DivOubliMotDePasse)
        var $a = $("<a href='javascript:void(0)' style='font-size:10px'>Annuler</a>").appendTo($DivoubliAnnule)
        $a.on("click", function () {
            $DivOubliMotDePasse.fadeOut(300, "swing", function () { $DivConnexion.fadeIn(300); dxAdrEmail.focus(); })
        });
        var $DivBt = $("<div style='text-align:center;padding-top:30px'/>").appendTo($DivOubliMotDePasse)
        var dxBtOubli = $("<div/>").appendTo($DivBt).dxButton({
            text: "Demander la réinitialisation",
            onClick: function (e) {
                if (!dxAdrEMailForOubli.option("value") || dxAdrEMailForOubli.option("value").length == 0) {
                    mNotify("Veuillez saisir l'adresse email de votre compte.", "error", 4000)
                    dxAdrEMailForOubli.focus();
                    return;
                }
                if (!dxAdrEMailForOubli.option("value").valideEmail()) {
                    mNotify("L'adresse email que vous avez saisie est erronée.", "error", 4000)
                    dxAdrEMailForOubli.focus();
                    dxAdrEMailForOubli.element().find("input").select();
                    return;
                }
                jaugeDemarrage.mShow();
                var dataToBeSent = {
                    command: 'demandereinitpwdwithemail',
                    adresse_email: dxAdrEMailForOubli.option("value"),
                    nom_table: "compte_client"
                }
                var url = '/ext/handlerexterne.ashx?timestamp=' + new Date().getTime();
                $.post(url, dataToBeSent, function (data) {
                    if (data.root.resultat == "ok") {
                        if (data.root.emailenvoye == "1") {
                            mNotify("Un email vous permettant de réinitialiser votre mot de passe vous a été envoyé. Veuillez consulter vos emails et suivre les instructions.<br/>(Si vous ne recevez pas notre email, vérifiez que celui-ci ne se trouve pas dans vos courriers indésirables)", "success", 25000)
                            $DivOubliMotDePasse.fadeOut(300, "swing", function () { $DivConnexion.fadeIn(300); dxPwd.focus(); })
                        } else {
                            mNotify("Impossible de vous envoyer un email. Veuiller vérifier l'adresse que vous avez saisie.", "error", 15000)
                        }
                    }
                    else {
                        if (typeof data.root.message != 'undefined') { mNotify(data.root.message, "error", 5000) }
                        else { mNotify("Impossible d'envoyer l'email.", "error", 15000); }
                    }
                }, 'json')
                    .fail(function (data) {
                        console.log(data.responseText)
                        mNotify("Impossible d'envoyer l'email.", "error", 15000);
                    })
                    .always(function (data) {
                        jaugeDemarrage.mHide();
                    });
            }
        }).dxButton("instance");

        dxPwd.focus()
    }

    function mRempliPourCompteExisteAvecBase() {
        $("<br/>").appendTo($DivConnexion)
        var $Div = $("<div style='text-align:center;font-size:140%;'/>").appendTo($DivConnexion)
        $Div.hide();
        $("<div>Vous disposez déjà d'un espace accessible via l'adresse</div>").appendTo($Div)
        $("<a href='" + parametre.url_appli + "?emalog=" + dxAdrEmail.option("value") + "' target='_self'>" + parametre.url_appli + "</a>").appendTo($Div)
        $Div.slideDown(700);
    }

    function mRempliStart() {

        var $DivIntro = $("<div/>").appendTo($DivDemarrage)
        var $DivBt = null
        //if (parametre.has_environnement_demo || parametre.isLocalhost || window.location.pathname.endsWith("/newadmin")) {
        //sur localhost, on peut créer des environnement de démo (attention, il faut une bdd gabarit demo)
        $("<div style='text-align:center;padding-top:20px;'>Choisissez comment vous désirez démarrer.<br/></div>").appendTo($DivIntro)
        $("<div style='text-align:center;font-size:80%;opacity:0.8;font-style:italic;'>À l’issue de la création de votre environnement, vous pourrez vous connecter en utilisant l’adresse e-mail et le mot de passe que vous avez renseignés.</div>").appendTo($DivIntro)

        var objSoc = option.bddCtrl.getObjet(option.bddCtrl.mGetArray("societe")[0])
        var cgvEnCours = objSoc.objetMetier.mGetCgvEnCours()
        var dxCtrlChkCgv = null
        var $TableCgv = null
        if (cgvEnCours != null) {
            var urlCgv = parametre.url_appli + "/" + option.bddCtrl.nom_base + "/" + cgvEnCours.id_cgv + "/cgv"
            $TableCgv = $("<table style='margin-top:20px;'/>").appendTo($DivIntro)
            var $Tr = $("<tr/>").appendTo($TableCgv)
            var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
            dxCtrlChkCgv = $("<div style='padding:5px 5px 5px 0;'/>").appendTo($Td).dxCtrlCheckBox({
                text: "Je déclare accepter les conditions générales d'utilisation"
            }).dxCtrlCheckBox("instance")
            var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                icon: "fas fa-arrow-up-right-from-square",
                txtTooltip: "Afficher les CGU",
                onClick: function (e) {
                    window.open(urlCgv, "_blank")
                }
            })
        }

        $DivBt = $("<div style='text-align:center;padding-top:40px'/>").appendTo($DivDemarrage)
        var $DivVide = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
            "style='padding:10px;width:100%;height:auto;text-align:left;margin-bottom:30px;line-height:1;'>" +
            "<div class='contenu'>" +
            "<span style='font-size:130%;font-variant:small-caps;' class='dx-theme-accent-as-text-color'>Démarrer avec un environnement vierge</span><br/>" +
            "<span style='font-size:80%;opacity:0.5;font-style:italic' class='detail'>Démarrer immédiatement avec un environnement vierge. Importez vos données et commencez à travailler. Evaluez " + parametre.nom + " pendant 15 jours puis décidez.</span>" +
            "</div>" +
            "</div>").appendTo($DivBt)
        var $DivIDBase = $("<div style='display:none;margin:10px;'/>").appendTo($DivVide.find(".contenu"))
        var $Table = $("<table/>").appendTo($DivIDBase)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style = 'width:100%'/>").appendTo($Tr)
        var dxTxtNomEnv = $("<div/>").appendTo($Td).dxCtrlTextBox({
            labelMode: 'floating',
            label: "Choisissez le nom de votre environnement",
            maxLength: 25,
            onInput: function (e) {
                const input = e.event.target;
                const cleaned = input.value.replace(/[^a-z0-9]/g, '');
                if (input.value !== cleaned) {
                    input.value = cleaned;
                    e.component.option("value", cleaned);
                    mNotify("uniquement des lettres et des chiffres en minuscules.", "warning", 6000)
                }
            }
        }).dxCtrlTextBox("instance")
        $("<div style='font-size:100%;opacity:0.5;font-weight: 100;line-height:1.2;font-family:barlow condensed;'>Le <b>nom de votre environnement</b> est utilisé pour les échanges avec le support, votre code parrainage et d'autres fonctionnalités... Choisissez un nom qui correspond à votre société et à votre travail ou gardez le nom qui vous est proposé.<br>Entre 8 et 25 caractères, uniquement des lettres et des chiffres en minuscules.</div>").appendTo($Td)
        var $Td = $("<td style = 'width:1px;vertical-align:top;'/>").appendTo($Tr)
        var lstNomEnvExiste = null
        $("<div class='allowcontextmenu' style='display:inline-block;padding-left:5px;'/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-arrow-right",
            height: 45,
            width: 45,
            onClick: function (e) {
                if (dxTxtNomEnv.option("value") == null || dxTxtNomEnv.option("value").length == 0) {
                    mNotify("Veuillez saisir un nom pour votre environnement.", "warning", 6000)
                    dxTxtNomEnv.focus()
                    return;
                }
                if (dxTxtNomEnv.option("value").length < 8) {
                    mNotify("Veuillez saisir un nom d'environnement entre 8 et 25 caractères.", "warning", 6000)
                    dxTxtNomEnv.focus()
                    return;
                }
                if (dxTxtNomEnv.option("value").startsWith("demo")) {
                    mNotify("Votre nom d'environnement ne peut commencer par le terme 'demo'.", "warning", 6000)
                    dxTxtNomEnv.focus()
                    return;
                }
                if (dxTxtNomEnv.option("value").endsWith("aagest")) {
                    mNotify("Ce nom d'environnement est déjà utilisé.", "warning", 6000)
                    dxTxtNomEnv.focus()
                    return;
                }
                if (lstNomEnvExiste.contains(dxTxtNomEnv.option("value"))) {
                    mNotify("Ce nom d'environnement est déjà utilisé.", "warning", 6000)
                    dxTxtNomEnv.focus()
                    return;
                }
                mCreateEnvironnement(false, dxTxtNomEnv.option("value"))
            }
        }).dxCtrlButton("instance");
        $DivVide.on("click", function (e) {
            if (dxCtrlChkCgv != null && !dxCtrlChkCgv.option("value")) {
                mNotify("Veuillez accepter les conditions générales d'utilisation.", "error", 6000)
                $TableCgv.addClass("blinkscale")
                dxCtrlChkCgv.element().find(".dx-checkbox-text").css("color", "red")
                window.setTimeout(function (e) { $TableCgv.removeClass("blinkscale") }, 5000)
            } else {
                $DivVide.off("click")
                option.bddCtrl.mAjaxCall({ "command": "getlstnombaseexisteETnewnombase" }, function (data) {
                    dxTxtNomEnv.option("value", data.new_name)
                    lstNomEnvExiste = data.lstname
                    if ($DivDemo) $DivDemo.slideUp(200)
                    $DivVide.find(".detail").hide()
                    $DivIDBase.slideDown(300, function () { dxTxtNomEnv.focus() })
                    //mCreateEnvironnement(false)
                })
            }
        })

        var $DivDemo = null
        if (parametre.has_environnement_demo) {
            $DivDemo = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
                "style='padding:10px;width:100%;height:auto;text-align:left;margin-bottom:30px;line-height:1;'>" +
                "<div>" +
                "<span style='font-size:130%;font-variant:small-caps;' class='dx-theme-accent-as-text-color'>Découvrir dans un environnement de démo</span><br/>" +
                "<span style='font-size:80%;opacity:0.5;font-style:italic'>Vous démarrer votre environnement avec des données de test en mode démo. Dans ce bac à sable, vous pouvez découvrir comment fonctionne le logiciel avant de passer à un environnement vierge pour accueillir vos données et commencer à travailler.<br/>ATTENTION, cet environnement sera <b>détruit à minuit</b> ce soir.</span>" +
                "</div>" +
                "</div>").appendTo($DivBt)
            $DivDemo.on("click", function (e) {
                if (dxCtrlChkCgv != null && !dxCtrlChkCgv.option("value")) {
                    mNotify("Veuillez accepter les conditions générales d'utilisation.", "error", 6000)
                    $TableCgv.addClass("blinkscale")
                    dxCtrlChkCgv.element().find(".dx-checkbox-text").css("color", "red")
                    window.setTimeout(function (e) { $TableCgv.removeClass("blinkscale") }, 5000)

                } else { mCreateEnvironnement(true) }
            })

            if (parametre.isLocalhost) {
                //création environnement de travail à partir d'un environnement de démo
                var $DivVideDemo = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
                    "style='padding:10px;width:100%;height:auto;text-align:left;margin-bottom:30px;line-height:1;'>" +
                    "<div class='contenu'>" +
                    "<span style='font-size:130%;font-variant:small-caps;' class='dx-theme-accent-as-text-color'>Démarrer avec un environnement de démo de travail</span><br/>" +
                    "<span style='font-size:80%;opacity:0.5;font-style:italic' class='detail'>Démarrer immédiatement avec un environnement initié à partir de l'environnemnt de démo.</span>" +
                    "</div>" +
                    "</div>").appendTo($DivBt)
                var $DivIDBaseDemo = $("<div style='display:none;margin:10px;'/>").appendTo($DivVideDemo.find(".contenu"))
                var $Table = $("<table/>").appendTo($DivIDBaseDemo)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style = 'width:100%'/>").appendTo($Tr)
                var dxTxtNomEnvDemo = $("<div/>").appendTo($Td).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: "Choisissez le nom de votre environnement",
                    maxLength: 25,
                    onInput: function (e) {
                        const input = e.event.target;
                        const cleaned = input.value.replace(/[^a-z0-9]/g, '');
                        if (input.value !== cleaned) {
                            input.value = cleaned;
                            e.component.option("value", cleaned);
                            mNotify("uniquement des lettres et des chiffres en minuscules.", "warning", 6000)
                        }
                    }
                }).dxCtrlTextBox("instance")
                $("<div style='font-size:100%;opacity:0.5;font-weight: 100;line-height:1.2;font-family:barlow condensed;'>Le <b>nom de votre environnement</b> est utilisé pour les échanges avec le support, votre code parrainage et d'autres fonctionnalités... Choisissez un nom qui correspond à votre société et à votre travail ou gardez le nom qui vous est proposé.<br>Entre 8 et 25 caractères, uniquement des lettres et des chiffres en minuscules.</div>").appendTo($Td)
                var $Td = $("<td style = 'width:1px;vertical-align:top;'/>").appendTo($Tr)
                var lstNomEnvExiste = null
                $("<div class='allowcontextmenu' style='display:inline-block;padding-left:5px;'/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-arrow-right",
                    height: 45,
                    width: 45,
                    onClick: function (e) {
                        if (dxTxtNomEnvDemo.option("value") == null || dxTxtNomEnvDemo.option("value").length == 0) {
                            mNotify("Veuillez saisir un nom pour votre environnement.", "warning", 6000)
                            dxTxtNomEnvDemo.focus()
                            return;
                        }
                        if (dxTxtNomEnvDemo.option("value").length < 8) {
                            mNotify("Veuillez saisir un nom d'environnement entre 8 et 25 caractères.", "warning", 6000)
                            dxTxtNomEnvDemo.focus()
                            return;
                        }
                        if (dxTxtNomEnvDemo.option("value").startsWith("demo")) {
                            mNotify("Votre nom d'environnement ne peut commencer par le terme 'demo'.", "warning", 6000)
                            dxTxtNomEnvDemo.focus()
                            return;
                        }
                        if (!parametre.isLocalhost && dxTxtNomEnvDemo.option("value").startsWith("burgerqueen") || dxTxtNomEnvDemo.option("value").startsWith("tricatel")) {
                            mNotify("Votre nom d'environnement ne peut commencer par le terme 'demo'.", "warning", 6000)
                            dxTxtNomEnvDemo.focus()
                            return;
                        }
                        if (dxTxtNomEnvDemo.option("value").endsWith("aagest")) {
                            mNotify("Ce nom d'environnement est déjà utilisé.", "warning", 6000)
                            dxTxtNomEnvDemo.focus()
                            return;
                        }
                        if (lstNomEnvExiste.contains(dxTxtNomEnvDemo.option("value"))) {
                            mNotify("Ce nom d'environnement est déjà utilisé.", "warning", 6000)
                            dxTxtNomEnvDemo.focus()
                            return;
                        }
                        mCreateEnvironnement(true, dxTxtNomEnvDemo.option("value"))
                    }
                }).dxCtrlButton("instance");
                $DivVideDemo.on("click", function (e) {
                    if (dxCtrlChkCgv != null && !dxCtrlChkCgv.option("value")) {
                        mNotify("Veuillez accepter les conditions générales d'utilisation.", "error", 6000)
                        $TableCgv.addClass("blinkscale")
                        dxCtrlChkCgv.element().find(".dx-checkbox-text").css("color", "red")
                        window.setTimeout(function (e) { $TableCgv.removeClass("blinkscale") }, 5000)
                    } else {
                        $DivVideDemo.off("click")
                        option.bddCtrl.mAjaxCall({ "command": "getlstnombaseexisteETnewnombase" }, function (data) {
                            dxTxtNomEnvDemo.option("value", data.new_name)
                            lstNomEnvExiste = data.lstname
                            if ($DivDemo) $DivDemo.slideUp(200)
                            $DivVideDemo.find(".detail").hide()
                            $DivIDBaseDemo.slideDown(300, function () { dxTxtNomEnvDemo.focus() })
                            //mCreateEnvironnement(false)
                        })
                    }
                })
            }
        }

        var $DivErreurCreation = $("<div style='padding-top:20px;color:red;font-size:110%;display:none;text-align:center;'>Nous avons rencontré un problème<br/>durant la création de votre environnement.<br/>Veuillez réessayer.</div>").appendTo($DivDemarrage)
        var $DivOkCreation = $("<div style='padding-top:20px;font-size:110%;text-align:center;'></div>").appendTo($DivDemarrage)


        function mCreateEnvironnement(demo, nomEnvironnement) {
            $DivErreurCreation.hide()
            jaugeDemarrage.mHide()
            window.setTimeout(function () {
                jaugeDemarrage.mShow()
                jaugeDemarrage.option("message", "Veuillez patienter<br/>pendant la création de votre environnement " + ((demo) ? "de démonstration" : "de travail"))
                var idx = 0
                jaugeDemarrage.mAvance(null, idx, 50)
                var timeOutAvanceJauge = null
                mAvanceJauge()
                function mAvanceJauge() {
                    idx += 1
                    jaugeDemarrage.mAvance(null, idx, 50)
                    timeOutAvanceJauge = window.setTimeout(function () { mAvanceJauge() }, 1000)
                }

                var email = dxAdrEmail.option("value")
                var pwd = dxPwd.option("value")
                var nom = (dxNom ? dxNom.option("value") : "")
                var tel = (dxTel ? dxTel.option("value") : "")
                var veuxPasSollication = (dxChkVeuPasEtreSollicite ? (dxChkVeuPasEtreSollicite.option("value") ? "1":"0") : "1")
                option.bddCtrl.mAjaxCall({
                    command: "creationenvironnement",
                    adresse_email: email,
                    pwd: pwd,
                    nom: nom,
                    tel: tel,
                    veux_pas_sollication_emai: veuxPasSollication,
                    id_type_offre: option.idTypeOffre,
                    lst_fonctionnalite: option.lstFonctionnalite,
                    demo: ((demo) ? "1" : "0"),
                    nom_environnement: nomEnvironnement,
                    timeout: 500000
                }, function (data) {
                    jaugeDemarrage.mHide()
                    if (data.baseok == "1") {
                        $DivIntro.slideUp(200)
                        if ($DivInfo) $DivInfo.slideUp(200)
                        if ($DivBt) $DivBt.slideUp(200)
                        $("<div style='font-size:140%;text-align:center;padding-bottom:10px;'>Votre environnement est prêt</div>").appendTo($DivOkCreation)
                        $("<div style='text-align:center;opacity:0.7;'>Pour vous connecter,<br/>utilisez votre adresse email<br/>(<u>" + email + "</u>)<br/>et le mot de passe que vous avez saisi.</div>").appendTo($DivOkCreation)
                        $("<div style='text-align:center;padding-top:30px;font-weight:bold;'>Rejoignez votre espace via l'adresse:</div>").appendTo($DivOkCreation)
                        var $DivLink = $("<div style='text-align:center;font-size:120%;'/>").appendTo($DivOkCreation)
                        $("<a href='" + parametre.url_appli + "?emalog=" + email + "' target='_self' style='display:inline-block;'>" + parametre.url_appli + "</a>").appendTo($DivLink)
                        $DivOkCreation.slideDown(200)
                        forcerFermetureNavigateur = true

                        //if (typeof option.onCreateEnvironnement != 'undefined') { option.onCreateEnvironnement() }
                        //else {
                        //    forcerFermetureNavigateur = true
                        //    window.open(parametre.url_appli, "_self")
                        //    mNotify("Votre environnement a été créé.", "success", 10000)
                        //}
                    } else if (data.baseok == "2") {
                        //on est en préprod !
                        //on miger sur la page de prod
                        var domaine = window.location.hostname.split('.').slice(-2).join('.');
                        domaine = domaine.substring(2)
                        window.open("app." + domaine + "/new", "_self");
                    } else {
                        $DivErreurCreation.show()
                    }
                }, function () {
                    window.clearTimeout(timeOutAvanceJauge)
                },
                    function (data) {
                        jaugeDemarrage.mHide()
                        $DivErreurCreation.show()
                    }, false);
            }, 500)

        }

        $DivConnexion.slideUp(1000)

    }

    this.element = function () { return container }

    mConstruit();
}